var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg14CircleFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 198.649C0 88.9385 88.938 0.000488281 198.649 0.000488281C204.918 0.000488281 210 5.08266 210 11.3518V190C210 201.046 201.046 210 190 210H11.3513C5.08217 210 0 204.918 0 198.649Z",
    fill: "#00ABB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14CircleFaq);
export default __webpack_public_path__ + "static/media/1-4-circle-faq.8243042a01637db6a12e60c337d5cd48.svg";
export { ForwardRef as ReactComponent };